import { Box, InputBase, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Flex from "../Flex";

interface SearchHeaderProps {
  value: string;
  resultCount: number;
  onChange: (v: string) => void;
}

export const SearchHeader = ({
  value,
  resultCount,
  onChange,
}: SearchHeaderProps) => {
  const theme = useTheme();
  return (
    <Flex
      alignItems="center"
      gap={1}
      sx={{
        // px: 1.25,
        // py: 0.75,
        backgroundColor:
          value.length > 0 ? "rgba(255, 214, 102, 0.18)" : "transparent",
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <InputBase
        autoFocus
        fullWidth
        placeholder="Type to Search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        startAdornment={
          <Box
            sx={{
              pl: 1.4,
            }}
          >
            <SearchIcon
              fontSize="small"
              // sx={{ color: theme.palette.text.secondary }}
            />
          </Box>
        }
        endAdornment={
          <Box
            sx={{
              pr: 1.4,
            }}
          >
            <Box
              sx={{
                px: 0.8,
                minWidth: 26,
                textAlign: "center",
                borderRadius: "10px",
                backgroundColor: theme.palette.grey[700],
                color: theme.palette.common.white,
                fontSize: "10px",
                fontWeight: 500,
              }}
            >
              {String(resultCount).padStart(2, "0")}
            </Box>
          </Box>
        }
        // sx={{ fontSize: "14px", flex: 1 }}
      />
    </Flex>
  );
};
